<template>
  <div class="listTable">
    <div class="tableNameTitle_block">
      <div class="tableNameTitle">
        <div class="toptableName">
          附件列表

          <div class="tableNameTitle_text" v-if="verification">
            {{ bankid }}
            <i class="el-icon-warning"></i> 您有文件未上传
          </div>
        </div>
      </div>
    </div>
    <!--   default-expand-all
    :expand-change="getfileListByMenu"
      :load="load"-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      lazy
      :row-style="{ height: '50px' }"
      default-expand-all
      row-key="id"
      header-row-class-name="tableheader"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column label="分类名称" width="350">
        <template slot-scope="scope">
          <i
            class="el-icon-folder-opened"
            v-if="scope.row.fileMenuSingle == 0"
          ></i>
          <i class="el-icon-document" v-else></i>

          <span class="file_wrapper">
              
                      
              <template
                v-if="
                  !scope.row.firstlist && scope.row.id && scope.row.baFileMenuId
                "
              >
                <el-tooltip
                  v-if="fileCanRedirectUrl(scope.row)"
                  class="item"
                  effect="dark"
                  content="点击查看全部附件"
                  placement="top-start">
                  <span
                    class="redirect-span"
                    @click="openAllFile(scope.row)"
                  >
                    {{ scope.row.fileName || scope.row.fileMenuName }}
                  </span>
                </el-tooltip>

                <a
                  v-else
                  class="file_button"
                  target="_blank"
                  
                  :href="
                      isWord(scope.row.fileUrl
                      ? scope.row.fileUrl
                      : scope.row.files.length > 0
                      ? scope.row.files[0].fileUrl
                      : '')
                        ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                          (scope.row.fileUrl
                      ? scope.row.fileUrl
                      : scope.row.files.length > 0
                      ? scope.row.files[0].fileUrl
                      : '')
                        : scope.row.fileUrl
                      ? scope.row.fileUrl
                      : scope.row.files.length > 0
                      ? scope.row.files[0].fileUrl
                      : ''
                    "
                >
                  {{
                    scope.row.fileName && scope.row.fileName != undefined
                      ? scope.row.fileName
                      : scope.row.fileMenuName
                  }}
                </a>
              </template>

              <!-- <el-tooltip
                v-else-if="canRedirectUrl(scope.row)"
                class="item"
                effect="dark"
                content="点击查看全部附件"
                placement="top-start">
                <span
                  class="redirect-span"
                  @click="openAllFile(scope.row)"
                >
                  {{ scope.row.fileName || scope.row.fileMenuName }}
                  {{ scope.row.dynamicName ? "——" + scope.row.dynamicName : ""}}
                </span>
              </el-tooltip> -->

              <span v-else>
                {{ scope.row.fileName || scope.row.fileMenuName }}
                {{
                  scope.row.dynamicName ? "——" + scope.row.dynamicName : ""
                }}
              </span>

              <i v-if="scope.row.fileMenuIsMust == 1" class="red_i">*</i>

              {{ fileList.length == 0 ? "" : fileList }}
            
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="大小" width="100">
        <template slot-scope="scope">
          {{ scope.row.baFileMenuId ? scope.row.fileSize : "" }}
        </template>
      </el-table-column>
      <el-table-column label="上传时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.baFileMenuId ? scope.row.createTime : "" }}
        </template>
      </el-table-column>
      <el-table-column label="上传人员" width="100">
        <template slot-scope="scope">
          {{ scope.row.baFileMenuId ? scope.row.userName : "" }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="actionscope">
            <div class="actionOnediv">
              <WordUpload
                v-if="upload"
                :PageId="PageId"
                :baFileMenuId="scope.row.baFileMenuId"
                :Id="scope.row.id"
                :fileMenuIsMust="scope.row.fileMenuIsMust == 1 ? true : false"
                :bankid="bankid"
                @update="getFileMenuList"
                @uploadProgress="uploadProgress"
              />

              <!--   :baFileMenuId="scope.row.baFileMenuId"
                :Id="scope.row.id" -->
              <!-- :Id="scope.row.id"  "bankid"-->
            </div>
            <div
              class="actionOnediv"
              v-if="
                !scope.row.firstlist && scope.row.id && scope.row.baFileMenuId
              "
            >
              <el-button
                type="text"
                icon="el-icon-download"
                @click="download(scope.row)"
                >下载</el-button
              >
            </div>
            <div
              class="actionOnediv redcolor"
              v-if="scope.row.id && scope.row.baFileMenuId && upload"
            >
              <el-button
                type="text"
                icon="el-icon-delete-solid"
                @click="deleteF(scope.row)"
                >{{
                  scope.row.fileMenuIsMust == 1 ? "清空" : "删除"
                }}</el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="progress_wrapper" v-if="progressFlag">
      <el-progress
        class="progress_modal"
        type="circle"
        :percentage="uploadPercent"
      ></el-progress>
    </div>
  </div>
  <!-- 
    *     <Accessory idname="银行管理" :upload="auditState" />
    *    
    *     idname  :附件名字 (String)  
    *     upload:ture  (Boolean)  是否显示上传
    *
    *     bankid: fileOtherId(页面订单id)
    *
    *    
    *
    *
    *
   -->
</template>

<script>
import * as api from "@/api/text/text";
import { downLoadTemplate } from "@/router/downLoadTem";
import WordUpload from "./wordUpload";

export default {
  name: "accessory",
  data() {
    return {
      tableData: [],
      PageId: "",
      fileList: [],
      listid: "",
      verification: false,
      progressFlag: false,
      uploadPercent: 0, 
    };
  },
  props: {
    idname: String,
    upload: Boolean,
    bankid: String,
  },
  computed:{
    
  },
  watch: {
    upload: {
      handler(newname, oldname) {
        if (oldname != undefined) {
          this.getPageId();
        }
      },
    },
  },
  components: {
    WordUpload
    
  },
  created() {
    this.getPageId();
  },
  methods: {
    fileCanRedirectUrl(row) {
      console.info(row, 'fileCanRedirectUrl')
      if(row.isTarget){
        return true
      }else {
        return false
      }
    },    
    canRedirectUrl(row) {
      if(
        row.children.length > 0 && 
        ((row.children[0].files && row.children[0].files.length > 0) ||
         (row.children[0].fileUrl && row.children[0].fileUrl != ''))
        ) {
        return true
      }else {
        return false
      }
    },
    openAllFile(row) {
      let replaceUrl = row.fileUrl
      let openUrl = replaceUrl.replace('open', 'openall')
      window.open(openUrl,"_blank")
    },

    beforeUpload(file, data) {
      // console.log(file);
      // console.log(data);
    },

    getPageId() {
      api
        .getFileMenuByName({ fileMenuName: this.idname })
        .then((res) => {
          this.PageId = res.data.data.id;
          this.getFileMenuList();
        })
        .catch((res) => {
          // console.log(res);
        });
    },
    //获取列表数据

    //
    getFileMenuList() {
      api
        .getFileMenuList({
          type: 1,
          menuId: this.PageId,
          fileOtherId: this.$route.params.id,
        })
        .then((res) => {
          // console.log(res.data);

          let tableData = res.data.data;
          // ------------

          // -----------------
          // res.data.data.map((itdata) => {

          let verification = [];
          let setNew = (data) => {
            return data.map((item) => {
              let obj = item;
              if (item.files && item.files.length > 0) {
                if (item.fileMenuIsMust == 1) {
                  item.userName = item.files[0].userName;
                  item.filesid = item.files[0].id;
                  item.fileSize = item.files[0].fileSize;
                  item.createTime = item.files[0].createTime;
                  item.baFileMenuId = item.files[0].baFileMenuId;
                } else {
                  let findTarget = false
                  item.files.map((itemfiles) => {
                    // itemfiles.isCheck=isCheckfather
                    itemfiles.filesid = itemfiles.id;
                    if((itemfiles.fileUrl.indexOf('.pdf') > -1 ||
                        itemfiles.fileUrl.indexOf('.xls') > -1 ||
                        itemfiles.fileUrl.indexOf('.xlsx') > -1 ||
                        itemfiles.fileUrl.indexOf('.doc') > -1 ||
                        itemfiles.fileUrl.indexOf('.docx') > -1) &&
                        findTarget == false)
                    {
                      itemfiles.isTarget = true
                      findTarget = true
                    }else {
                      itemfiles.isTarget = false
                    }                    
                    item.children.push(itemfiles);
                  });
                }
              } else {
                if (item.fileMenuIsMust == 1) {
                  verification.push(false);
                }
              }

              if (item.children && item.children.length > 0) {
                obj.children = setNew(item.children);
              }
              return obj;
            });
          };

          // if (itdata.files && itdata.files.length > 0) {
          //   if (itdata.fileMenuSingle == 1) {
          //     itdata.userName = itdata.files[0].userName;
          //     itdata.id = itdata.files[0].id;
          //     itdata.fileSize = itdata.files[0].fileSize;
          //     itdata.createTime = itdata.files[0].createTime;
          //     itdata.baFileMenuId = itdata.files[0].baFileMenuId;
          //   } else {
          //     itdata.files.map((itemfiles) => {
          //       itdata.children.push(itemfiles);
          //     });
          //   }
          // }
          // });
          setNew(tableData);
          let tableListData = tableData;
          // let tableListData = res.data.data.map(item => {
          //   return {
          //     ...item,
          //     children: item.children.map(el => {
          //       return {
          //         ...el,
          //         hasChildren: true
          //       };
          //     })
          //   };
          // });
          // console.log(tableListData);
          // hasChildren: true
          // let tableListData = res.data.data;
          // tableListData.forEach(item => {
          //   item.firstlist = 1;
          //   api
          //     .getFileListByMenu({
          //       // baFileMenuId: this.PageId,
          //       baFileMenuId: item.id,
          //       fileOtherId: this.bankid,
          //       fileName: ""
          //     })
          //     .then(res => {
          //       res.data.data.data.map(itdata => {
          //         item.children.push(itdata);
          //       });
          //     });
          //   item.children.forEach(ites => {
          //     api
          //       .getFileListByMenu({
          //         baFileMenuId: ites.id,
          //         fileName: ""
          //       })
          //       .then(res => {
          //         if (ites.fileMenuIsMust !== 1) {
          //           ites.children = res.data.data.data;
          //         } else {
          //           if (res.data.data.data.length > 0) {
          //             // console.log(res.data.data.data);
          //             ites.baFileMenuId = ites.id;
          //             ites.id = res.data.data.data[0].id;
          //             ites.fileName = res.data.data.data[0].fileName;
          //             ites.fileSize = res.data.data.data[0].fileSize;
          //             ites.createTime = res.data.data.data[0].createTime;
          //             ites.userName = res.data.data.data[0].userName;
          //             this.verification = false;
          //           } else {
          //             this.verification = true;
          //           }
          //         }
          //       });
          //   });
          // });
          this.tableData = tableListData;
          this.progressFlag = false;
          this.uploadPercent = 0;
          // console.log(tableListData)
        });
    },
    // getfileListByMenu(row) {
    //   console.log(row);
    // },
    // 上传成功后获取
    // handsuccess(response, file, fileList) {
    //   console.log(response, file, fileList);
    //   // this.fileList;
    //   // this.$nextTick({});
    // },
    // httprequest(val) {
    //   let formData = new window.FormData();

    //   formData.append("file", val.file);
    //   formData.append("data", 1);
    //   api
    //     .saveFile(formData)
    //     .then(res => {
    //       //请示下一个接口 ， 并且刷星列表
    //     })
    //     .catch(res => {
    //       //提示错误
    //     });
    // },

    load(tree, treeNode, resolve) {
      api
        .getFileListByMenu({
          baFileMenuId: tree.id,
          fileOtherId: this.bankid,
          fileName: "",
        })
        .then((res) => {
          // ites.children = res.data.data.data;
          resolve(res.data.data.data);
        });
      // console.log(tree, treeNode, resolve);
    },
    download(row) {
      // console.log(row);
      if (row.baFileMenuId == undefined) {
        downLoadTemplate("/api/file/downAll", {
          id: row.id,
          menuId: this.PageId,
        }).finally(() => {
          this.loading = false;
          this.$message({
            type: "success",
            message: "已下载",
          });
        });
      } else {
        downLoadTemplate("/api/file/down", { id: row.filesid }).finally(() => {
          this.loading = false;
          this.$message({
            type: "success",
            message: "已下载",
          });
        });
      }
    },

    deleteF(row) {
     
      if (row.fileMenuIsMust == 1) {
        api
          .deleteAllFileByOtherId({
            fileOtherId: this.bankid,
            baFileMenuId: row.baFileMenuId,
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getFileMenuList();
          })
          .catch((res) => {
            // console.log(res);
          });
      } else {
        api
          .deleteFileMenu({ fileId: row.id })
          .then((res) => {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getFileMenuList();
          })
          .catch((res) => {
            // console.log(res);
          });
      }
    },
    
    // 加载
    uploadProgress(uploadPercent,progressFlag) {
     
      this.progressFlag = progressFlag;
      this.uploadPercent=uploadPercent
    },
  },
};
</script>

<style lang="scss" scoped>
.listTable {
  margin-top: 20px;
  margin-bottom: 20px;
  .redirect-span{
    text-decoration: underline;
    cursor: pointer;
  }
  .tableNameTitle_block {
    display: flex;
    background: #f9f9f9;
    flex-direction: row;
    align-items: center;
    border-radius: 15px 15px 0 0;
    line-height: 55px;
    color: rgba(255, 115, 0, 0.904);
  }
  .tableNameTitle {
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    color: #333;
    line-height: 60px;
    border: 1px solid #e2e2e2;
    border-bottom: 1px solid #ebeef5;
    border-radius: 10px 10px 0 0;
    padding: 0 20px;
    .toptableName {
      display: flex;
      font-weight: 700;
      font-size: 16px;
      flex-direction: row;
      .tableNameTitle_text {
        font-size: 13px;
        margin-left: 60px;
        color: rgb(245, 108, 108);
        // margin-left: 10px;
      }
    }
  }

  .tableheader {
    th {
      background: #e7e7e7;
      color: #000000;
    }
  }
  .action_block {
    display: flex;
    flex-direction: row;
    a {
      cursor: pointer;
      margin: 0 8px;
    }
  }
}
.red_i {
  color: red;
  font-size: 21px;
}
.actionscope {
  display: flex;
  flex-direction: row;
  .actionOnediv {
    margin: 0 8px;
  }
}
.redcolor {
  color: rgb(223, 73, 73);
  .el-button--text {
    color: rgb(223, 73, 73);
    &:hover {
      color: rgb(243, 168, 168);
    }
  }
}
.tableNameTitle_text {
  // padding-top: 15px;
}
.el-table {
  border-top: none;
}
// .el-table--border td:first-child .cell,
// .el-table--border th:first-child .cell {
//   padding-left:20px;
// }
/deep/ .el-table td,
.el-table th {
  padding: 0;
}
/deep/.el-table th > .cell {
  padding-left: 20px;
  font-weight: 500;
}
/deep/.el-table th {
  background: none;
}
/deep/ .el-table .cell,
.el-table th > .cell {
  padding: 0 20px;
}
/deep/.el-table--border td:first-child .cell,
/deep/.el-table--border th:first-child .cell {
  padding-left: 20px;
}
.file_wrapper {
  
  min-height: 35px;
  .file_button {
    display: contents;
    color: #333333;
    font-weight: 400;
    &:hover {
      color: #409eff;
    }
  }
}
.progress_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0,0.3);
  z-index: 2000;
  .progress_modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
